import { useEffect, useState } from 'react'

import { RedirectRequest } from '@azure/msal-browser'
import { InteractionRequiredAuthError } from '@azure/msal-common'

import { msalInstance } from '../../index'
import Config from '../config'

export async function acquireTokenSilent(): Promise<any> {
  const account =
    msalInstance.getActiveAccount() ||
    msalInstance.getAllAccounts()[0] ||
    undefined

  const request: RedirectRequest = {
    scopes: Config.auth.scopes,
    account: account,
    redirectUri: window.location.href,
  }

  if (!request.account) {
    return
  }

  try {
    const result = await msalInstance.acquireTokenSilent(request)
    if (!result.accessToken) throw new Error('Error fetching token silently!')
    return result.accessToken
  } catch (error) {
    if (error instanceof InteractionRequiredAuthError) {
      await msalInstance.acquireTokenRedirect(request)
    }
  }
}

function useAccessToken(): string | undefined {
  const [accessToken, setAccessToken] = useState<string | undefined>(undefined)

  useEffect(() => {
    acquireTokenSilent().then(result => setAccessToken(result))
  }, [])

  return accessToken
}

export default useAccessToken
